const ConditionalProfileCard = importCond<
	typeof import('./main.tsx'),
	typeof import('./async.tsx')
>('empanada_team_profilecard_trial_sync_trigger', './main.tsx', './async.tsx');

// below is a pre-existing lint violation, don't add more eslint-disable for this rule please!!
// eslint-disable-next-line @atlaspack/no-importcond-exports
export default ConditionalProfileCard;
